import styled from 'styled-components';

export const Group = styled.div`
  background: white;
  min-height: 100%;
`
